import React from "react"

interface ClassBoxProps {
  number: number
  selected: boolean
  onClick?: () => void
}

export default function ClassBox({ number, selected, onClick }: ClassBoxProps) {
  return (
    <button
      onClick={onClick}
      className={`
        w-12 h-12 flex items-center justify-center
        rounded-md border-2 font-semibold text-lg
        ${selected ? "border-blue-800 bg-blue-100 text-blue-800" : "border-blue-800 bg-white text-blue-800"}
      `}
    >
      {number}
    </button>
  )
}
